<table mat-table [dataSource]="dataSource" *ngIf="!isLoading && evidenceData.length > 0">
    <ng-container [matColumnDef]="key" *ngFor="let key of tableColumnObject">
        <th mat-header-cell *matHeaderCellDef class="survey-details-link "
            [ngClass]="{'hide-on-mobile': ['photoName', 'sectionHeading', 'controlName'].indexOf(key) > -1}">
            <span>{{tableKeys[key]}}</span>
        </th>
        <td mat-cell *matCellDef="let evidence; let i = index" class="survey-details-link cell-field"
            (click)="onRowClick(i); $event.stopPropagation()" [style.--numShown]="tableColumnObject.length"
            [style.--numShownMobile]="tableColumnObject.length-3"
            [ngClass]="{'hide-on-mobile overflow-ellipsis': ['photoName', 'sectionHeading', 'controlName'].indexOf(key) > -1}">

            <ng-container *ngIf="evidence[key]; else notAvailable">
                <span *ngIf="key === 'date'; else nonDateField">
                    {{ evidence[key] | date :'dd MMM y' }}
                </span>
                <span *ngIf="key === 'storeID'">
                    <span *ngIf="evidence['storeName']">{{ evidence[key] }} - {{ evidence['storeName'] }}</span>
                    <span *ngIf="!evidence['storeName']">{{ evidence[key] }}</span>
                </span>
                <ng-template #nonDateField>
                    <span>{{evidence[key]}}</span>
                </ng-template>
            </ng-container>

            <ng-template #notAvailable>
                <span class="light-grey medium-text">
                    None
                </span>
            </ng-template>
        </td>
    </ng-container>

    <!-- Action column for View button -->
    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="survey-details-link center-align action-column">
            <h4></h4>
        </th>
        <td mat-cell *matCellDef="let evidence; let i = index"
            class="survey-details-link center-align cell-field action-column">
            <a class="view-link" (click)="onRowClick(i); $event.stopPropagation()">View</a>
        </td>
    </ng-container>

    <mat-header-row *matHeaderRowDef="getDisplayedColumns()" class="survey-heading-line"></mat-header-row>
    <mat-row *matRowDef="let evidence; columns: getDisplayedColumns(); let i = index" class="survey-line"></mat-row>
</table>

<div *ngIf="isLoading" class="loader-container">
    <div class="loading-wapple"></div>
</div>

<div *ngIf="evidenceData.length === 0 && !isLoading" class="no-evidence-container">
    <h3 class="none-found-message">
        {{noEvidenceMessage}}
    </h3>
</div>